export default __webpack_public_path__ + "static/media/provesional_restoration_upper_22_4@2x.0bc38697.png";